import { defineStore } from 'pinia'

/** 与路由 query 一致，用于打开订阅详情抽屉 */
export type SubscribeDetailsDrawerQuery = Record<string, string | string[] | undefined>

function normalizeQuery (q: Record<string, unknown>): SubscribeDetailsDrawerQuery {
  const out: SubscribeDetailsDrawerQuery = {}
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === null) continue
    if (Array.isArray(v)) {
      out[k] = v.map(item => String(item))
    } else {
      out[k] = String(v)
    }
  }
  return out
}

export const useSubscribeDetailsDrawerStore = defineStore('subscribeDetailsDrawer', {
  state: () => ({
    visible: false,
    /** 每次 open 递增，强制抽屉内组件重新挂载 */
    instanceKey: 0,
    query: {} as SubscribeDetailsDrawerQuery,
    /** 批量续订入口（服务到期等），由父组件以 prop 传给 SubscribeDetails */
    renewAll: false,
  }),
  actions: {
    open (params: Record<string, unknown> = {}, options?: { renewAll?: boolean }) {
      this.query = normalizeQuery(params)
      this.renewAll = !!options?.renewAll
      this.instanceKey += 1
      this.visible = true
    },
    close () {
      this.visible = false
      this.renewAll = false
    },
  },
})
